import { supabase } from "../../supabaseClient";

/**
 * Updates a bowler's average in the tournamentAverages table
 * @param {string} bowlerId - The ID of the bowler
 * @param {string} tournamentId - The ID of the tournament
 * @param {number|null} average - The new average value (null if no average)
 * @param {boolean} hasAverage - Whether the bowler has an average
 * @returns {Promise<{error: Error|null}>} - Returns an object with any error that occurred
 */
export const updateBowlerAverage = async (
  bowlerId,
  tournamentId,
  average,
  hasAverage = true
) => {
  try {
    // If bowler has no average, set average to null
    if (!hasAverage) {
      average = null;
    } else {
      // Handle empty strings and convert to null
      if (average === "" || average === null || average === undefined) {
        average = null;
      } else {
        // Validate the average is within range only if bowler has average
        if (isNaN(average) || average < 0 || average > 300) {
          throw new Error("Average must be between 0 and 300");
        }
      }
    }

    // Upsert the average into the tournamentAverages table
    const { error } = await supabase.from("tournamentAverages").upsert(
      {
        bowlerID: bowlerId,
        tournamentID: tournamentId,
        average: average,
        hasAverage: hasAverage,
      },
      { onConflict: "bowlerID,tournamentID" }
    );

    if (error) throw error;

    // Clear the tournament details cache to ensure fresh data on next load
    sessionStorage.removeItem(`tournamentDetails_${tournamentId}`);

    return { error: null };
  } catch (error) {
    console.error("Error updating bowler average:", error);
    return { error };
  }
};
